// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bgx_a bhn_ea bhn_a","LoadingSwitch__init":"bgx_b bhn_a bhn_w bhn_j bhn_ul bhn_um bhn_fm"};